import { Tab, Tabs } from '@material-ui/core'

import React from 'react'
import { useHistory } from 'react-router'

interface IMessageTemplateTabs {
  activeTab: 'messages' | 'categories' | 'suggestions'
}

export const MessageTemplateTabs = (props: IMessageTemplateTabs) => {
  const history = useHistory()

  return (
    <Tabs>
      {['messages', 'categories', 'suggestions'].map(tab => (
        <Tab
          key={tab}
          label={tab.charAt(0).toUpperCase() + tab.slice(1)}
          value={tab}
          style={
            props.activeTab === tab
              ? {
                  fontWeight: 'bold',
                  color: '#000',
                  borderBottomColor: '#000',
                  borderBottomWidth: 1,
                  borderBottomStyle: 'solid'
                }
              : {}
          }
          selected={props.activeTab === tab}
          onClick={() => {
            history.push(tab === 'messages' ? '/message-templates' : `/message-templates/${tab}`)
          }}
        />
      ))}
    </Tabs>
  )
}
